import { Modal, Box, Paper, Typography, Grid, IconButton } from "@mui/material";
import { Button } from "../../../../components/Button/Button";
import { Formik, Form } from "formik";
import FieldCheckbox from "../../createEditProfile/formFragments/FieldCheckbox";
import { CustomSelectField } from "../../applicationForm/customSelect";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";

const EditSelectedModal = ({ open, onClose, shortlists, handleSubmit }) => {
  const initialValues = {
    status: "",
    isParent: false,
    isEmailSubscriber: false,
    isInstagramFollower: false,
    proSpotlight: false,
    shortlist: "",
  };

  const [isChanged, setIsChanged] = useState(false);

  const detectChanges = (values) => {
    const hasChanges = Object.keys(values).some(
      (key) => values[key] !== initialValues[key]
    );
    setIsChanged(hasChanges);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        component={Paper}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "900px",
          maxHeight: "90vh",
          bgcolor: "var(--surface)",
          borderRadius: "12px",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            sx={{
              color: "var(--Base-1000, #000)",
              fontFamily: '"Circular Std", sans-serif',
              fontSize: "24px",
              fontWeight: 900,
              lineHeight: "132%",
            }}
          >
            Edit Selected
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <hr style={{ margin: "24px 0", color: "var(--border)" }} />

        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            const updatedValues = Object.keys(values).reduce((acc, key) => {
              if (values[key] !== initialValues[key]) {
                acc[key] = values[key];
              }
              return acc;
            }, {});

            handleSubmit(updatedValues);
          }}
        >
          {({ values, handleChange }) => {
            useEffect(() => {
              detectChanges(values);
            }, [values]);

            return (
              <Form>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <CustomSelectField
                      name="status"
                      label="Status"
                      required={false}
                      options={[
                        "Active",
                        "Inactive",
                        "In Negotiation",
                        "In Review",
                        "Prospect",
                      ]}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <CustomSelectField
                      name="shortlist"
                      label="Shortlist"
                      required={false}
                      options={(Array.isArray(shortlists) ? shortlists : shortlists?.rows || []).map((e) => ({
                        label: e.name,
                        value: e.id,
                      }))}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldCheckbox text="Parent" name="isParent" />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldCheckbox
                      text="Email Subscriber"
                      name="isEmailSubscriber"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldCheckbox
                      text="Instagram Follower"
                      name="isInstagramFollower"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <FieldCheckbox text="Pro Spotlight" name="proSpotlight" />
                  </Grid>
                </Grid>

                <Box display="flex" justifyContent="flex-end" mt={4} gap={3}>
                  <Button
                    variant="outlined"
                    sx={{
                      mr: 2,
                      textTransform: "capitalize",
                      color: "#916A3B",
                      borderColor: "#916A3B",
                      "&:hover": { bgcolor: "#F8F4EE" },
                    }}
                    onClick={onClose}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      textTransform: "capitalize",
                      bgcolor: isChanged ? "#7B542D" : "#916A3B",
                      opacity: isChanged ? 1 : 0.5,
                      cursor: isChanged ? "pointer" : "not-allowed",
                      "&:hover": {
                        bgcolor: isChanged ? "#7B542D" : "#916A3B",
                      },
                    }}
                    disabled={!isChanged}
                  >
                    Save Changes
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Modal>
  );
};

export default EditSelectedModal;
